class CountingDegreeController extends AbstractController
	@register()
	@inject '$rootScope',
		'$filter'
		'MessageTypes'
		'priceRegions'
		'UserInformation'

	MAX_TIME_PERIOD: 60 * 60 * 24 * 31 * 15 # 15 months

	initialize: ->
		@reportFilter =
			priceRegionId: @UserInformation.getMasterUser().price_region_id
			startDate:
				moment()
					.subtract(3, 'months')
					.set({hour: 0, minute: 0, second: 0})
					.unix()
			endDate: moment().unix()

		@datePickerConfig = singleDatePicker: true
		@reportFormats = ['csv', 'pdf']

	onTimePeriodChange: ->
		@resetErrors()

		if @endDate - @startDate > @MAX_TIME_PERIOD
			@addErrorMessage(
				@$filter('translate')('general.time.period'),
				@$filter('translate')('wbo.stock.counting.degree.time.period.validation.max.length')
			)

		if @startDate >= @endDate
			@addErrorMessage(
				@$filter('translate')('general.time.period'),
				@$filter('translate')('wbo.stock.counting.degree.time.period.validation.start.less.than.end')
			)
